module.exports = __webpack_public_path__ + "media/public/images/social/facebook-hover-cf46c3afa484f2bda1f30409328ae023.svg";